import { render, staticRenderFns } from "./BackdoorView.vue?vue&type=template&id=0805d780&scoped=true"
import script from "./BackdoorView.vue?vue&type=script&lang=js"
export * from "./BackdoorView.vue?vue&type=script&lang=js"
import style0 from "./BackdoorView.vue?vue&type=style&index=0&id=0805d780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0805d780",
  null
  
)

export default component.exports